/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";
const BASE_PATH = `${API_BASE_SRC}/turnos`;
export const CONFIRMAR = `${BASE_PATH}/confirmar`;
export const GET_CITAS = `${BASE_PATH}/getCitas`;
export const GET_SUCURSALES = `${BASE_PATH}/getSucursales`;
export const GET_TRAMITES = `${BASE_PATH}/getTramites`;
export const GET_DIAS = `${BASE_PATH}/getDiasMultiples`;
export const GET_HORAS = `${BASE_PATH}/getHoras`;
export const CREAR_TURNO = `${BASE_PATH}/crearTurno`;
